import { push } from "react-router-redux";

export const changePage = (url) => {
  return push("/" + url);
};
